import { RestaurantOrderInformationsMobile } from "./RestaurantOrderInformationsMobile";

export default RestaurantOrderInformationsMobile;
